// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"77cc77da","799":"77cc77da"}[chunkId] + ".css";
};